import type { Patient } from '@/types/api';
// The module itself, not the dictation barrel: that one pulls in browser-only components.
import { fold } from '../dictation/parser/lexicon/fold';

const words = (s: string) => fold(s).split(/\s+/).filter(Boolean).sort().join(' ');

/**
 * The patient whose name is exactly what was said, in either order
 * ("Kiss Anna" or "Anna Kiss", accents and Cyrillic ignored); null when none
 * or several match, so the name is kept as typed.
 */
export function matchPatient(spoken: string, candidates: readonly Patient[]): Patient | null {
  const said = words(spoken);
  if (!said) return null;
  const hits = candidates.filter((p) => words(`${p.firstName} ${p.lastName}`) === said);
  return hits.length === 1 ? (hits[0] ?? null) : null;
}
